import { styled } from '../jss-style';
import transferStyle from './transfer';

const useTransferStyle = styled(transferStyle, 'transfer');

export { transferStyle, useTransferStyle };
export default useTransferStyle;
